import { faPhoneVolume as fasPhoneVolume } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { MortgageLeadFormStepProps } from "@/component/Mortgage/LeadForm/Steps/LeadForm";
import { LeadForm as ParentLeadForm } from "@/component/Mortgage/LeadForm/Steps/LeadForm";

export class LeadForm<
	TProps extends MortgageLeadFormStepProps = MortgageLeadFormStepProps,
> extends ParentLeadForm<TProps> {
	public static defaultProps = {
		...ParentLeadForm.defaultProps,
		title: "",
		button: "Eredmény küldése",
		withLoanAmount: false,
	};

	protected renderHeader(): ReactNode {
		return (
			<Card.Header>
				<div className="d-flex py-2 align-items-center">
					<div className="pr-2">
						<FontAwesomeIcon icon={fasPhoneVolume} className="fa-3x text-gold" />
					</div>
					<div className="small border-left pl-2">
						Kérd részletes eredményeidet email-ben és várd szakértőnk hívását, hogy segítsen a felmerülő
						kérdések tisztázásában!
					</div>
				</div>
			</Card.Header>
		);
	}
}
